import React, { useState } from 'react';
import VerificationsComponent from './VerificationsComponent';
import { VERIFICATION_DATA_QUERY } from 'features/verification/queries';
import { RETRY_DOCUMENT_VERIFICATION } from '../mutations';
import { DOCUMENT_VERIFICATION_UPDATED } from '../subscriptions';
import { useConditionalSubscription, useMutation } from 'features/common/security/hooks';
import { useSimpleError, useQueryWithSimpleErrorHandling } from 'hooks';
import ExpansionSummaryVerificationComponent from './ExpansionSummaryVerificationComponent';
import PropTypes from 'prop-types';
import { emptyArray } from 'constants/defaultValues';

const VerificationsContainer = ({ documentId }) => {
  const showError = useSimpleError();
  const [verificationsData, setVerificationsData] = useState(emptyArray);
  const { loading } = useQueryWithSimpleErrorHandling(VERIFICATION_DATA_QUERY, {
    variables: { documentId },
    fetchPolicy: 'network-only',
    skip: !documentId,
    onCompleted: ({ verificationData }) => {
      setVerificationsData(verificationData.verifications);
    }
  });

  const [showLinkModal, setShowLinkModal] = useState(false);
  const [selectedVerification, setSelectedVerification] = useState(null);

  const [retryVerification] = useMutation(RETRY_DOCUMENT_VERIFICATION, {
    onError: error => showError(error)
  });

  const handleOpenModal = verification => {
    setShowLinkModal(true);
    setSelectedVerification(verification);
  };

  const handleCloseModal = () => {
    setShowLinkModal(false);
  };

  const handleRetryVerification = documentVerificationId => {
    retryVerification({
      variables: {
        input: {
          documentId,
          documentVerificationId
        }
      }
    });
  };

  useConditionalSubscription(DOCUMENT_VERIFICATION_UPDATED, {
    onData: ({ data: { data } }) => {
      var updatedVerification = verificationsData.find(
        x => x.documentVerificationId === data.documentVerificationUpdated.verification.documentVerificationId
      );
      if (updatedVerification) {
        setVerificationsData(prevState =>
          prevState.map(verification =>
            verification.documentVerificationId === updatedVerification.documentVerificationId
              ? data.documentVerificationUpdated.verification
              : verification
          )
        );
      } else setVerificationsData(prevState => [...prevState, { ...data.documentVerificationUpdated.verification }]);
    }
  });

  return (
    <>
      {!loading && verificationsData && (
        <VerificationsComponent
          verifications={verificationsData}
          onOpenLink={handleOpenModal}
          onRetryVerification={handleRetryVerification}
        />
      )}
      {showLinkModal && !loading && (
        <ExpansionSummaryVerificationComponent onCloseModal={handleCloseModal} verification={selectedVerification} />
      )}
    </>
  );
};

VerificationsContainer.propTypes = {
  documentId: PropTypes.number
};

export default VerificationsContainer;
